exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.note-editable {\n    font-family: none !important;\n}\n/* Add any additional styling if needed */\n", ""]);

// exports
